<app-loading-overlay />
<app-toast position="top-left" />
<app-toast position="top-center" />
<app-toast position="top-right" />
<app-toast position="bottom-left" />
<app-toast position="bottom-center" />
<app-toast position="bottom-right" />
<app-toast position="center" />
<router-outlet />
